import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Toast/sgds-toast-container";
import { register } from "../../utils/ce-registry";

register("sgds-toast-container", Component);

export default createComponent({
  react: React,
  tagName: "sgds-toast-container",
  elementClass: Component,
  events: {}
});
